import { Platform } from 'react-native';
export const parseSideSpace = (props) => {
    const { sideSpace, getRem } = props;
    const result = { top: 0, right: 0, bottom: 0, left: 0 };
    if (!sideSpace) {
        return result;
    }
    const arr = sideSpace
        .toString()
        .split(' ')
        .map((v) => {
        let r = Number.parseInt(v, 10);
        if (getRem) {
            r = getRem(r);
        }
        return r;
    });
    switch (arr.length) {
        case 4:
            return { top: arr[0], right: arr[1], bottom: arr[2], left: arr[3] };
        case 3:
            return { top: arr[0], right: arr[1], bottom: arr[2], left: arr[1] };
        case 2:
            return { top: arr[0], right: arr[1], bottom: arr[0], left: arr[1] };
        case 1:
            return { top: arr[0], right: arr[0], bottom: arr[0], left: arr[0] };
        default:
            return result;
    }
};
let hasInjectWebCss = false;
// web场景下去除Input、TextArea组件的outline
export const injectWebCss = () => {
    if (Platform.OS !== 'web' || hasInjectWebCss) {
        return;
    }
    hasInjectWebCss = true;
    const style = document.createElement('style');
    style.textContent = 'textarea, input { outline: none }';
    const styleStepper = document.createElement('style');
    styleStepper.textContent = `.Stepper-input-wrap {
        position: absolute;
        top: 0;
    }
    .Stepper-textInput {
        position: absolute;
        top: 0;
        width: 100%;
        flex-shrink: 1;
        flex-grow: 0;
        justify-content: center;
        align-items: stretch;
        text-align: center;
        border: none;
        -moz-appearance: textfield;
    }
    .Stepper-textInput::-webkit-outer-spin-button,
    .Stepper-textInput::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .Stepper-textInput:focus {
        border: none;
    }`;
    return document.head.append(style, styleStepper);
};
const _requestAnimationFrame = requestAnimationFrame;
const _cancelAnimationFrame = cancelAnimationFrame;
/**
 * @description requestAnimationFrame
 * @param  {()=>void} handler
 * @param  {number} timeout?
 */
export const raf = (handler) => {
    return _requestAnimationFrame.call(window, handler);
};
/**
 * @description cancelAnimationFrame
 * @param  {number} handle
 */
export const cancelRaf = (handle) => {
    _cancelAnimationFrame(handle);
};
/**
 * @description 为属性固定的静态对象赋值,例如reactive，替代通过.多次访问 减少代码量
 * @param  {T} target
 * @param  {T} source
 */
export const staticObjectAssign = (target, source) => {
    Object.keys(source).forEach((key) => {
        if (source[key] !== undefined &&
            Object.prototype.hasOwnProperty.call(target, key)) {
            target[key] = source[key];
        }
    });
};
export function pick(obj, keys, ignoreUndefined) {
    return keys.reduce((ret, key) => {
        if (!ignoreUndefined || obj[key] !== undefined) {
            ret[key] = obj[key];
        }
        return ret;
    }, {});
}
export function noop() { }
